'use client';

import PaginationStyle from './style';

import { useApiPagination } from '@/hooks/useApiPagination';

export default function Pagination({ pagination }) {
  const { goTo } = useApiPagination();

  if (!pagination?.prev && !pagination?.next) return null;

  return (
    <PaginationStyle>
      <div className="pagination-links">
        {pagination.prev && (
          <button
            type="button"
            className="blog-pagination-prev"
            onClick={() => goTo(pagination.prev)}
          >
            ← Previous
          </button>
        )}

        {pagination.next && (
          <button
            type="button"
            className="blog-pagination-next"
            onClick={() => goTo(pagination.next)}
          >
            Next →
          </button>
        )}
      </div>
    </PaginationStyle>
  );
}
